import { Observable } from 'rxjs'
import { ModelRepository } from './model-repository'
import { BaseModel } from './../models/base-model'

export abstract class ModelRepositoryAdapterMock<T extends BaseModel> {

  constructor(private _repository: ModelRepository, private ModelType: {name: string}) { }

  public findModelById(id: number, includeRelations: string[] = []): Observable<T> {
    return Observable.of(null)
  }

  public findAllModels(includeRelations: string[] = []): Observable<T[]> {
    return Observable.of([])
  }

  public findModelsBy(searchCriteria: any, includeRelations: string[] = []): Observable<T|T[]> {
    return Observable.of([])
  }

  public save(model: any): Observable<T> {
    return Observable.of(null)
  }

  public delete(model: T): Observable<T> {
    return Observable.of(null)
  }

  protected initialize(includes: string[] = [], filters: any = {}): void {
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/model-repository-adapter.mock.ts